export interface ApiResponse<T> {
  // code?: number;
  // date?: string;
  // result: T;
  // error?: string;
  Header: ApiResponseHeader;
  Body: T;
}

export type ApiListResponse<T> = ApiResponse<T[]>

export type ApiPageableResponse<T> = ApiResponse<InternalApiPageableResponse<T>>

interface InternalApiPageableResponse<T> {
  response: T[];
  Header: T[];
  Body: T[];
  page: Page;
}

interface Page {
  number?: number;
  totalElements?: number;
  totalPages?: number;
  first?: boolean;
  last?: boolean;
}

export interface BEBase {
  Codice: string;
  Descrizione: string;
  Tipo: string;
}

export interface BEBase2 {
  Codice: string;
  Descrizione: string;
  Id: string;
}

export interface ApiResponseHeader {
  Mitt: string;
  Dest: string;
  TicketInt: string;
  TicketExt: string;
  Tipo_Interfaccia: string;
  Data: string;
  Codice: string;
  esito: number;
  Descrizione: string;
  Severita: string;
}
